import React, { useEffect } from 'react';
import { HeroSection } from '../components/SalesPage/HeroSection';
import { ProblemSection } from '../components/SalesPage/ProblemSection';
import { SolutionSection } from '../components/SalesPage/SolutionSection';
import { BenefitsSection } from '../components/SalesPage/BenefitsSection';
import { BonusesSection } from '../components/SalesPage/BonusesSection';
import { ValueTableSection } from '../components/SalesPage/ValueTableSection';
import { DecisionSection } from '../components/SalesPage/DecisionSection';
import { FinalCTASection } from '../components/SalesPage/FinalCTASection';
import { PricingSection } from '../components/SalesPage/PricingSection';
import { Footer } from '../components/SalesPage/Footer';
import { trackPageView } from '../hooks/useMetaPixel';
export function SalesPage() {
  useEffect(() => {
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans selection:bg-brand-gold/30 selection:text-brand-charcoal-dark" data-id="element-325">
      <HeroSection data-id="element-326" />
      <ProblemSection data-id="element-327" />
      <SolutionSection data-id="element-328" />
      <BenefitsSection data-id="element-329" />
      <BonusesSection data-id="element-330" />
      <ValueTableSection data-id="element-331" />
      <DecisionSection data-id="element-332" />
      <FinalCTASection data-id="element-333" />
      <PricingSection data-id="element-334" />
      <Footer data-id="element-335" />
    </div>;
}